<div *ngIf="isLoginHeader; else loggInHeader" class="header-container">
  <nav class="navbar navbar-expand-lg bg-dark border-bottom border-body h-100" data-bs-theme="dark">
    <div class="container-fluid">
      <a [routerLink]="[]" (click)="toggleSidenav()"><img src="../../../../assets/images/toggle-header-idec.svg"
          alt="Hamburger"></a>
      <a class="navbar-brand d-flex align-items-center w-50 mr-auto px-4">
        <div class="d-flex align-items-center">
          <span class="title-header"><span class="login-logo-1">iDEC Echo</span><div class="vl"></div></span>
        </div>
        <div class="rt-filter header-menu" *ngIf="sharedService.getTenantAvailability()">
          <mat-form-field appearance="outline">
            <mat-select [disableOptionCentering]="true" name="item" [formControl]="selectedTenant"
              (selectionChange)="tenantChange($event)">
              <mat-option *ngFor="let item of tenantList" [value]="item">
                {{item.name | titlecase}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="header-refresh-button cursor" (click)="apiRefresh()">
          <span class="image-rotate"><img src="../../../../assets/images/header-api-refresh.svg"
              title="Refresh data in this page" class="h-14 cursor" alt="api refresh"></span><span
            class="inline-block mr-2">Refresh</span>
        </div>
      </a>
      <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor01"
        aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse" id="navbarColor01">
        <ul class="navbar-nav ml-auto mb-2 mb-lg-0 align-items-end column-gap-3 header-last-child">
          <li title="Full Screen" *ngIf="!isFullScreen" class="d-flex align-items-end header-flex-item"><img
              src="../../../../assets/images/fullView.svg" (click)="fullScreen()" class="header-logo cursor" alt="full view">
          </li>
          <li title="Exit" *ngIf="isFullScreen" class="d-flex header-flex-item">
            <img src="../../../../assets/images/Mini-view.svg" (click)="fullScreen()" class="header-logo cursor"
              alt="full view" *ngIf="isFullScreen">
          </li>
          <li class="nav-item dropdown position-relative header-flex-item">
            <a [matMenuTriggerFor]="exportPop" #popTrigger="matMenuTrigger" (click)="popTrigger.openMenu();"
              class="cursor pdl-15">
              <img src="../../../../assets/images/people_avatar.svg" class="header-logo" alt="avatar">
            </a>
            <ng-container>
              <mat-menu #exportPop="matMenu" [hasBackdrop]="true">
                <div class="d-flex flex-column profile-pop-wrapper" (click)="$event.stopPropagation();">
                  <!-- avatar -->
                  <div class="d-flex gap20">
                    <div class="avatar-wrapper">
                      <img src="../../../../assets/images/people_avatar.svg" class="h-100" alt="avatar">
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <span class="user-name-pop">{{userFullName | titlecase}}</span>
                    </div>
                  </div>

                  <div class="d-flex align-items-center flex-end">
                    <div (click)="logout()" class="cursor">
                      <span>
                        <img src="../../../../assets/images/logout-header-idec.svg" alt="logout">
                      </span>
                    </div>
                  </div>
                </div>
              </mat-menu>
            </ng-container>

          </li>
          <li class="updated-time-style header-flex-item text-right">
            {{refreshTime |
            date:'medium'}}
          </li>
        </ul>

      </div>
    </div>
  </nav>
</div>


<ng-template #loggInHeader>
  <div class="px-3 login-header">
    <div>
      UST
    </div>
    <div>
      ECHO
    </div>
  </div>
</ng-template>